<template>
    <b-row  style="position:relative;" v-bind:class="[{ busy: busy}, 'opacity-transition']">
        <pb-spinner v-if="busy"></pb-spinner>
        <b-col>
            <b-form-group
                    :id="name"
                    :label="label"
                    :label-for="name">
                <v-select
                        :disabled="busy"
                        :searchable="true"
                        :clearable="false"
                        @input="update"
                        label="name"
                        :reduce="tile => tile.id"
                        :value="value"
                        :options="tiles">
                </v-select>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
    import ContentAPI from "../../../../../shared/_api/cms/content";

    export default {
        name: 'DesignShopTileSelect',
        props: ['placeholder', 'label', 'name', 'value', 'inline'],
        data() {
            return {
                tiles: [],
                busy: false
            };
        },
        mounted() {
            this.busy = true;
            ContentAPI.fetchListByName("design-shop").then((list) => {
                this.tiles = list.map(tile => {
                    return {
                        id : tile.id,
                        name: tile.identifier.value
                    }
                })
            }).finally(() => {
                this.busy = false;
            })
        },
        methods: {
            update: function (tile) {
                this.$emit('input', tile);
            }
        }
    }

</script>

<style lang="scss" scoped>
</style>